import { Component } from '@angular/core';

@Component({
    selector: 'app-dashboardsupport',
    templateUrl: './dashboardsupport.component.html',
    styleUrls: ['./dashboardsupport.component.scss'],
    standalone: false
})
export class DashboardsupportComponent {

}
